import React, {useState, useCallback, useContext} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { View, Text } from 'react-native';
import { CREATE_PADDLE_SERVICE } from './queries';
import { useLazyQuery } from '@apollo/client';
import { formatAssetNameForSelect } from '../../utils/formatAssetName';
import Autocomplete from '../Autocomplete';
import AuthContext from '../../contexts/AuthContext';
import { PADDLE_SERVICE_CODES } from '.';
import { LinkSpace } from '../../elements';

const NewPaddleService = ({setShowModal, refetch}) => {
  const [submitting, setSubmitting] = useState();
  const [createPaddleService] = useMutation(CREATE_PADDLE_SERVICE, {
    onCompleted: (response) => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    input.sort = parseInt(input.sort || '99');
    createPaddleService({ variables: input });
  });

  const { control, handleSubmit, register, watch, setValue, getValues,
      formState: { errors } } = useForm({
    defaultValues: {
      name: '',
      code: '',
      serviceFeePercent: '',
      additionalFeePercent: 10,
      sort: 99,
      presaleScreen: true,
      applySalesTaxByDefault: false,
    }
  });

  const watchServiceFeePercent = watch('serviceFeePercent');
  const watchAdditionalFeePercent = watch('additionalFeePercent');

  return (
    <View>
      {submitting ?
        <DataState.Loading /> :
        <View>
          <Input.Text
            label="Name:"
            name="name"
            control={control}
            errors={errors}
            {...register("name", {
              required: true,
            })}
          />
          <Input.Text
            label="Code:"
            name="code"
            control={control}
            errors={errors}
            {...register("code", {
              required: true,
            })}
          />
          <Input.Number
            label="Sort (lower numbers listed first on sale screens):"
            name="sort"
            control={control}
            errors={errors}
            {...register("sort", { required: true, })}
          />
          <Input.Switch
            label="Include on Pre-sale screen toggles?"
            name="presaleScreen"
            control={control}
            errors={errors}
          />
          <Input.Switch
            label="Apply sales tax by default? (in-house/floor channels)"
            name="applySalesTaxByDefault"
            control={control}
            errors={errors}
          />
          <Input.Number
            label="Paddle Service Fee - Percent of Sale Price:"
            name="serviceFeePercent"
            control={control}
            errors={errors}
            {...register("serviceFeePercent", {
              required: true,
              validate: {
                matchPattern: (v) =>
                  /\d{1,10}(\.{1}\d{1,2}){0,1}?$/.test(v) ||
                  "Please use number only without commas",
              },
            })}
          />
          <Input.Number
            label="Additional Percent added for Buy Fee:"
            name="additionalFeePercent"
            control={control}
            errors={errors}
            {...register("additionalFeePercent", {
              required: true,
              validate: {
                matchPattern: (v) =>
                  /\d{1,10}(\.{1}\d{1,2}){0,1}?$/.test(v) ||
                  "Please use number only without commas",
              },
            })}
          />
          <View style={{display: 'flex', flexDirection: 'row'}}>
            <Text>Total Buy Fee Percent:</Text>
            &nbsp;&nbsp;
            { watchServiceFeePercent && watchAdditionalFeePercent &&
              parseFloat(watchServiceFeePercent) + parseFloat(watchAdditionalFeePercent)
            }
            %
          </View>
          <ButtonContainer>
            <ButtonGroup>
              <Button
                label="Create Paddle Service"
                onPress={handleSubmit(onSubmit)}
                style={{width: 'fit-content'}}
              />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewPaddleService;
